import React, { useEffect, useState } from "react";
import "./Dropdown.scss";

// Icons used
import { ArrowDown, ArrowUp, CalenderIcon } from "../../icons/Icons";

const Dropdown = ({
  name, // Input name (used for form submission via hidden input)
  options = [], // Array of selectable options: { label: string, value: any, selected?: boolean }
  size = "md", // Size variant for styling: 'sm', 'md', 'lg'
  className = "", // Custom CSS class(es)
  disabled = false, // If true, disables interaction
  placeholder = "Select Item", // Placeholder text when no option is selected
  onChange, // Callback when an option is selected
}) => {
  /* === useState === */
  const [open, setOpen] = useState(false); // Controls dropdown open/close state
  const [selected, setSelected] = useState(null); // Stores selected option
  /* === End useState === */

  /* === useEffect === */
  useEffect(() => {
    const preselected = options.find((opt) => opt.selected);
    if (preselected) {
      setSelected(preselected);
      if (onChange) onChange(preselected.value); // Notify parent of initial value
    }
  }, [options]); // Preselect the option with `selected: true` from props (like defaultValue)
  /* === End useEffect === */

  /* === Event Handler === */
  // Handles selection of an option
  const handleSelect = (option) => {
    if (disabled) return; // Prevent action if disabled
    setSelected(option); // Set selected option
    setOpen(false); // Close dropdown
    if (onChange) onChange(option.value); // Notify parent
  };
  /* === End Event Handler === */

  return (
    <div
      className={`dropdownWrapper ${size} ${className} ${
        disabled ? "disabled" : ""
      }`}
    >
      <input
        type="hidden"
        name={name}
        value={selected?.value || ""}
        disabled={disabled}
      />

      <div className="borderWrapper w-100">
        <div
          className={`dropdownSelect borderInner ${className}`}
          onClick={() => !disabled && setOpen((prev) => !prev)}
          tabIndex={disabled ? -1 : 0} // Make focusable unless disabled
          onBlur={() => setTimeout(() => setOpen(false), 150)} // Close after losing focus
        >
          <span
            className={selected?.label ? "textLabel selected" : "textLabel"}
          >
            {selected?.label || placeholder}{" "}
          </span>
          <span className={selected?.label ? "arrow selected" : "arrow"}>
            {open ? <ArrowUp size={size} /> : <ArrowDown size={size} />}{" "}
          </span>
        </div>
      </div>

      {/* Dropdown Options List */}
      {open && (
        <div className="dropdownOptionBox">
          <div className="borderWrapper w-100">
            <div className={`dropdownOptionInner borderInner `}>  {/* removed ${className} from here  */}
              {options.map((opt) => (
                <div
                  key={opt.value}
                  className={
                    selected?.value === opt.value
                      ? "selected dropdownOption borderWrapperJustOneCorner"
                      : "dropdownOption borderWrapperJustOneCorner"
                  }
                  onClick={() => handleSelect(opt)}
                >
                  {opt.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
